import { ApiClientService, EntityApiService, RequestConfig } from '@dfl/react-security';
import { CUSTOMER_CARE_ACTIONS_METRIC } from '../interfaces/ICustomerCareActionsReport';

class AnalyticCustomerCareActionsService extends EntityApiService<any> {
  searchByMetric = (metric: CUSTOMER_CARE_ACTIONS_METRIC, params?: any, config?: RequestConfig): Promise<any> => {
    return this.handleResponse(ApiClientService.post(this.getPath(`/${metric}`), params, config));
  };
}

const ANALYTICS_BASE_URL = process.env.REACT_APP_ANALYTICS_URL || '';

export default new AnalyticCustomerCareActionsService(
  `${ANALYTICS_BASE_URL}/ms-analytics/api/v1/customer-care-actions-analytics`,
);
